import type { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';
import { Button } from '@george-labs.com/design-system';

import { getFeatureConfig } from '@luna/feature-config';
import { getToken } from '@shared/auth';

import { DevToolsButton } from '../DevToolsButton';
import { loadAlexProxySessionDetailsLink } from './SessionDetailsLinkService';
import { isReplayingAlexProxySession } from './ProxyCardService';

const DEV_PROXY_RECORDINGS_URL = 'https://dev-proxy.kek.g-labs.io/#/recordings';
const DEV_PROXY_SESSION_URL = 'https://dev-proxy.kek.g-labs.io/#/sessions';

export const SessionDetailsLink: FunctionComponent = () => {
    const [sessionLink, setSessionLink] = useState('');

    useEffect(() => {
        if (getFeatureConfig((config) => config.alexProxyVersion) === 'v1') {
            loadAlexProxySessionDetailsLink().then(setSessionLink);
        } else if (isReplayingAlexProxySession()) {
            setSessionLink(`${DEV_PROXY_SESSION_URL}/${getToken()}`);
        } else {
            setSessionLink(DEV_PROXY_RECORDINGS_URL);
        }
    }, []);

    return (
        <DevToolsButton
            isLoading={!sessionLink}
            href={sessionLink}
            target="_blank"
            icon={Button.ICON.ARROW_OUT}
        >
            Open session details
        </DevToolsButton>
    );
};
